import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Impulzivnost",
  "description": "",
  "published": "2006-11-11T00:00:00.000Z",
  "redirect_from": ["/blog/impulzivnost/swizec/361"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Danes se je izkazal za nekaj zelo impulzivnega in nenavadnega, saj je bilo kar nekaj dogodkov, ki so se pripetili na cisti bazi impulzov.`}</p>
    <p>{`Tako je na primer prislo do nakupa novih las, s katerimi sem spremenil svojo glavo in moram reci da je izpadlo kar v redu. Spremembe je bila velika, saj so lasje spremenili iz dolzine do mojih moskih josk na malo krajse kot do brade. Vse skupaj se je tudi zgodilo na pravi nacin hecnih oseb, ker sem tja prisel in iz zepa potegnil sliko Deppa iz filma Secret Window in rekel, naj mi naredijo take lase ter jih tudi dobil.`}</p>
    <p>{`Druga stvar pa je bilo nenaden nakup najbednejsega med bednimi casopisi v drzavi (Direkt) samo zato, ker je bil zraven DVD Fawlty Towers. Malo sem se sicer opekel ker so na njem le tri epizode pa se to ne v prevec dobri kvaliteti ...`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      